import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'QUITUS',
  title: 'Che cos\'è la File Legale?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Il File Legale è la sintesi del vostro fascicolo amministrativo. La sua validità dipende dal vostro fascicolo legale. Questo documento espone il vostro fascicolo amministrativo nel momento in cui lo generate e vi permette di attestare la vostra conformità amministrativa.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'I vostri clienti hanno così una visione d\'insieme di tutti i vostri documenti e sono informati della regolarità della vostra situazione. L\'aggiornamento dei documenti amministrativi è fondamentale per garantire ai vostri clienti che siete in regola.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_QUITUS/IT_QUITUS_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Per scaricare il file, vai alla scheda documento e clicca su «Scarica lo status del file»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_QUITUS/IT_QUITUS_2.png`
  }]
};
